<template>
  <div class="main">
    <div class="main-title">{{ $t('lang.mz.one.wt_child.title') }}</div>
    <div class="main-content">
      <div class="question">{{ $t('lang.mz.one.wt_child.js') }}</div>
      <div class="answer scroll">
        <el-input
          type="textarea"
          resize="none"
          :rows="15"
          placeholder=""
          v-model="answer"
        >
        </el-input>
      </div>
      <div class="submit">
        <div class="btn">{{ $t('lang.mz.one.wt_child.sub') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Knowledge from '@/components/experimentation/knowledge.vue'
export default {
  components: { Knowledge },
  data() {
    return {
      answer: '',
    }
  },
  computed: {
    serverURL() {
      return this.publicData.serverUrl
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  padding: 0;
  border-radius: 5px;
  background-color: #FFF;
  &-title {
    height: 10%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #444444;
    font-size: 1.14583vw;
    font-weight: bold;
    border-bottom: 2px solid #f0bbbb;
  }
  &-content {
    width: 100%;
    height: 90%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 1.8% 2.94%;
    font-size: 18px;
    .answer {
      max-height: 85%;
      margin: 2% 0;
    }
    .submit {
      display: flex;
      justify-content: center;
    }
  }
}
</style>